import { useEffect } from "react";
import { Outlet } from "react-router-dom";
import { useIntl } from "@/infra/locale";
import { type NetworkStatusChangeEventPayload, TAURI_EVENTS } from "@/infra/tauri/events";
import { loggerService } from "@akina/infra";
import { OfflinePage, useIsOffline } from "@akina/presentation";
import { isApp } from "@akina/utils";
import { getCurrentWindow } from "@tauri-apps/api/window";

export const ConnectionStatusPage = () => {
  const { formatMessage } = useIntl();
  const isOffline = useIsOffline(state => state.isOffline);
  const setIsOffline = useIsOffline(state => state.setIsOffline);

  useEffect(() => {
    if (!isApp) return;
    try {
      const window = getCurrentWindow();

      const listen = async () => {
        try {
          await window.listen<NetworkStatusChangeEventPayload>(TAURI_EVENTS.NETWORK_STATUS_CHANGE, event => {
            setIsOffline(event.payload !== "Online");
          });
        } catch (error) {
          loggerService.error("Failed to listen for network status changes:", error);
        }
      };

      listen();
    } catch (_) {
      // do nothing
    }
  }, []);

  if (!isApp) return <Outlet />;
  return (
    <div className="relative">
      <div className={`${isOffline ? "pointer-events-none opacity-0" : ""}`}>
        <Outlet />
      </div>
      {isOffline ? (
        <div className="absolute inset-0 z-9999">
          <OfflinePage formatMessage={formatMessage} />
        </div>
      ) : null}
    </div>
  );
};
